import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

interface PrivateProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateProps> = ({ children }) => {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) return setIsValid(false);

      try {
        await axios.get(`${API_BASE_URL}/auth/verify`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setIsValid(true);
      } catch {
        setIsValid(false);
      }
    };

    verifyToken();
  }, [token]);

  if (isValid === null) return null; // or a loading spinner
  return isValid ? <>{children}</> : <Navigate to="/login" />;
};

export default PrivateRoute;
